// This is in a seperate file so Vue and external js
// files can both access the same mitt instance
import mitt from "mitt";
export const emitter = mitt();
